module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch4"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/chap4.jpg",
      "width": "61%"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _vm._v("N"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("OT LONG BEFORE")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _vm._v("F"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("LORA’S FLIGHT,")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _vm._v("L"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("OVE HAD MATERIALIZED IN")]), _vm._v(" Venice, a city made more beautiful by the fact that it was doomed. He stood in Piazza San Marco, in front of an ornate church named for the man who’d run naked from the garden of Gethsemane after Jesus was sentenced to death. Mark’s bones had been smuggled there in a barrel of salted pork — a strange way to keep a man and his memory alive. But what was humanity if not deeply strange?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was from similar human bones that they’d fashioned the dice for the Game. Two of them, carved and smoothed to perfection, their dots painted in a wine-dark mix of Love’s blood and Death’s tears. These, Love carried with him always. They rattled in his pocket as he strolled toward the Campanile, with its bell that rang periodically to summon politicians, announce midday, and herald executions.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The bell chimed noon as he passed, his shoes tapping the stones loudly enough to rouse a flock of pigeons. Up they rose into the silvery sky, cooing and beating their wings.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Love spent a pleasant if chilly afternoon in the misty, labyrinthine alleys of the Accademia quarter, half expecting to see his opponent around every corner. At a milliner’s, he purchased a handmade bowler, leaving his old hat on the head of a skinny Romany boy who would grow up to be a legendary seducer of women and men. For years afterward, Love regretted not giving the boy his pants.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("At the stationer’s next door, he bought a small bottle of cerulean ink because it reminded him of the shade Napoleon had used in his letters to Josephine. Love would record notes with it in the small book he always carried; perhaps it would improve his luck. Perhaps this time, unlike all the other times, he would win.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Wondering whether she had forsaken him, he stopped at a café for a snack of paper-thin prosciutto paired with a mild, milky cheese, washing both down with a glass of sparkling wine. Although his immortal body required neither food nor drink, he liked to pause for such simple pleasures. The appetite was a fundamentally human thing, and it served him to feel it, to understand it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When he emerged from the shop, his tongue buzzing with salt and wine, the sun was low on the horizon, pulling with it all the color and warmth from the world. Fearing Death would not join him after all, Love vanished and rematerialized inside a glossy black gondola, much to the surprise of the man who’d just dropped off his last passenger of the day. The gondolier had intended to roll a cigarette and stare at the heavens a few moments before he returned his boat to the yard. And yet, here was a new fare, already making himself comfortable on a black-and-gold bench.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The man sighed and spoke. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("“Solo voi due?”")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Just the two of you?")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Too late, Love caught a whiff of something sweet over the fetid odor of the canal. Lilies. The hairs on the back of his neck rose.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“Sì, solo noi due,”")]), _vm._v(" Love agreed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She descended the crooked set of wooden steps leading down to the gondola, looking like an angel in a long coat of winter-white wool. Her gloves and boots, made of lambskin, were the same hue. A lone spot of color hung around her neck: a red cashmere scarf. His heart sank at the sight of her in this shade.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hello, old friend,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Love helped her into the gondola. Judging her age to be about seventeen this time, he resolved to adjust his own appearance to match. His decision to travel in the guise of someone middle-aged had been a reflection of the weariness he felt with his lot. To spend an eternity losing was enough to make anyone feel damaged by time. But the younger he felt, the more he believed Death was beatable. He would have to remember that.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Mind if I smoke?” the gondolier asked, a skinny hand-rolled cigarette already between his lips.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Death answered, “Please do.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And there it was, her Mona Lisa smile, the one that had been the model for the artist. Then came the hiss of flame, the sour whiff of burning tobacco, the dull sizzle of the match as it sank into the canal, one more light, unlike any other, forever gone from the world.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The gondolier, now lost in smoke and thought, eased his craft from the dock and steered them from the Grand Canal through the quiet and picturesque privacy of the narrow water lanes snaking through the quarter.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“A hopeless city,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Death knew he loved Venice. To deprive her of the satisfaction of wounding him, Love altered his guise so he was wearing a swooping handlebar mustache. Death sprouted a drooping Fu Manchu, but did not crack a smile. Love acknowledged the win, and both their mustaches vanished.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You don’t have to be embarrassed,” she said in a language known only to the two of them. “It’s appealing, your commitment to the doomed.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Perhaps I see things you don’t,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Perhaps that is true.” She removed a glove and dipped a knuckle into the water.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“They’re ready,” he said, thinking of his player in the city far away, a city with a model of Venice’s Campanile built at its train station.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“If you say so,” Death said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The sun and all its light were gone. It would rise again, creating the illusion that the world had been remade, that the cycle was starting anew. But time was not a circle. It moved in one direction only, onward into the dark unknown. Feeling his spirits teeter, Love focused on the sound the water made as the boat sliced through it. A series of small kisses.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He looked into the heart of the gondolier and discovered the woman the man loved most. He cast that image overhead so that it might settle over the boat like a soft blanket. Surely Death would not object to that small comfort. The gondolier extinguished his cigarette in the canal and opened his mouth to sing. “ ’O Sole Mio.” My sun.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Love’s light spread overhead, and the darkening sky revealed a moon whittled to near nothingness. Reflections of human-made lights stretched across the water, beautiful fingers that stroked the slender boat as it passed, its captain singing of the glow of his heart’s sun on his lover’s face.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Love’s pulse steadied. He took Death’s hand so she could better see into his mind, and together, they looked at the city on the young edge of the world. Seattle. There was a wildness to it. Oceans of corruption, yes. But imagination and hope and wonder that attracted people who yearned to remake bigger and better lives. There were vast fortunes to be cut from forests and chipped from gold mines.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There was also opportunity for the poor to rise. The landscape itself reflected this. Still, deep lakes and frothing rivers. Snow-covered mountains whose beauty belied their explosive origins. If ever there were a place where the old might give way to the new, where Love could beat Death, it was here.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He wished he could see into Death’s mind the way she peered into his. He did not know the secret of it. The ride ended, and Love paid the gondolier extravagantly. Arm in arm, the two immortals glided off the boat, up the steps, and onto the arc of the Ponte dell’Accademia, their steps barely audible over the insistent slap of water.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Paper?” She held out her hand.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Love tore a sheet from the book he always carried.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You first,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Love pricked his finger and offered it to her. She lifted a tear from the corner of her eye and rubbed her fingertip against his. Love handed her the paper and the pen he’d purchased earlier. She dipped the metal tip into their strange ink and wrote two names. The ritual was quick, almost anticlimactic, but they’d performed it many times, and what’s more, knew each other well.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She blew on the ink. “This binds the players to the game. They live as long as this is intact. When the clock runs out, I’ll destroy the paper and claim my prize.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Only if you win,” Love said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“When I win. And what constitutes victory?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Love paused. In the past, he’d said a kiss. Or consummation. But neither seemed enough. “They must choose courage,” he said. “They must choose each other at the cost of everything else. When they do that, I win.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I do not even know what that means,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Love chose to show her with a picture painted in thought. He put his hands on Death’s cheeks and concentrated on the players. On the surface, they were an impossible pair. From two separate worlds. But Love knew something Death did not, at least when it came to hearts. Theirs were twins. He sent her an image of what it would look like when they locked on to each other. The light within them would burst out and rise, two columns of flame winding like the strands of matter that are the stuff of life itself. The image echoed both the creation of the universe in miniature and the elements of life on earth writ large. It was the source of everything, including Love and Death themselves.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("If Love won, it would remake the world, at least for the players.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Death pulled her face away. “Don’t ever do that again.” She put a hand on her cheek. “We of course cannot tell the players about the Game.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He nodded. To tell them would change everything. “And the stakes this time?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her answer was swift. “When I win, I claim the life of my player.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“When I win,” Love said, “both players live on.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She shrugged. Her powers were far greater than his, and the Game was only something she agreed to for the fun of it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Is there anything that isn’t allowed?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He hated this question. He’d made the wrong choice many times. “The usual restrictions. Before time runs out, you cannot kill either player with a touch, just as I cannot instill love.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Unless.” Death held up a finger.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Unless what?” She was a slippery opponent.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Unless your player chooses me. Then I can kill him with a kiss.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Love laughed. Henry would never choose death. Not over life. And certainly not over love. He’d been born for this. “As you wish. Have you chosen your guise?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re looking at it. At one of them, anyway.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In the near darkness, Love studied Death’s face. Star-white skin. A smart, wavy black bob. Dark eyes. The wide, insolent mouth. He’d seen her face before, but where? She’d also undoubtedly appear as the black cat. How her guises would affect the players was ever a mystery.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And now to determine the length of the Game,” Death said. “You have the dice, I trust.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Love removed the dice from his pocket. The bones clacked against each other. “You first.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ll roll the month, then.” She rattled the dice in her hands and tossed them on the boards of the bridge. “Three and four. The Game lasts until July. Which day is up to you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He could add the sum of the dots or multiply them, so long as their product did not exceed the length of the month. He hated having the choice. He would rather blame fate.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He squeezed the dice, kissed his hand, and let them fly. Their clatter echoed over the water.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Death read them. “How droll. A tie.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Even the numbers were the same, a four and a three. Love nearly chose the twelfth of July as the day the Game would end. That would give him more time, the thing he always wished for. Sometimes, even minutes would have made the difference.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But there was something about the symmetry of the seventh that called to him. So he trusted it. The Game would end at midnight on the seventh of July.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“When will I see you again?” He liked to know what she was doing so he could adjust his interventions to match.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Two days,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Love nodded. A pair of days felt right.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Death disappeared, as she did when she’d tired of his presence, and Love wandered, dazed, in the other direction until he found himself standing in front of a nearly empty café. He ate alone in the ancient square, a simple plate of gnocchi with a tart red wine, watching the stars find their way out of the darkening night sky.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The Game had begun. He ached for the players.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a0e70bb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9780545755863_ch004.vue
// module id = 78
// module chunks = 0